// extracted by mini-css-extract-plugin
export var card = "gallery-card-module--card--0FS5o";
export var header = "gallery-card-module--header--Ig9Mx";
export var icon = "gallery-card-module--icon--EzpzQ";
export var iconBox = "gallery-card-module--icon-box--NYq3U";
export var imgWrapper = "gallery-card-module--img-wrapper--HRfqx";
export var text = "gallery-card-module--text--8htVL";